module.exports = __webpack_public_path__ + "static/media/metamask.d5cb0c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/metamask.png
// module id = 591
// module chunks = 0